<template>
  <nav @mouseleave="profileMenuOpen = false">
    <div class="container">
      <div class="navbar display--flex justify-content-between align-item-center">
        <a href="/"><img src="@/assets/images/logo-b.svg" alt="Logo" class="logo-img" /></a>
        <div class="header-navigation-wrapper" :style="{ marginLeft: !sidebarCollapsed ? '240px' : '60px' }" >
          <div v-if="headerDetails[route.name]?.back" class="back-button-wrapper" @click="goBack(headerDetails[route.name]?.link)">
            <LeftOutlined class="back-button" />
          </div>
          <component :is="headerComponent" :header="headerDetails[route.name]?.label ?? ''" :type="headerDetails[route.name]?.type ?? null" />
        </div>
        <div class="navbar__back-cabinet">
          <back-cabinet-btn/>
        </div>
        <div class="display--flex align-item-center">
          <img
              id="specialButton"
              @click="clickOnSpecial"
              class="specialButton"
              style="cursor: pointer"
              src="@/assets/images/icons/eye-icon-new.svg"
              alt="ВЕРСИЯ ДЛЯ СЛАБОВИДЯЩИХ"
              title="ВЕРСИЯ ДЛЯ СЛАБОВИДЯЩИХ"
          />
          <div v-if="user" class="display--flex align-item-center">
            <ul class="navbar__icons display--flex">
              <li>
                <notification-window />
              </li>
            </ul>
            <a-dropdown
                placement="bottomRight" trigger="click" style="padding: 0 !important;">
              <template #default>
                <a-button
                    type="text"
                    class="navbar__profile"
                    @click="profileMenuOpen = !profileMenuOpen"
                >
                  <img
                      v-if="user.image"
                      :src="`${imageUrl}/storage/${user.image}`"
                      alt="user"
                      class="profile-avatar"
                  />
                  <img
                      v-else
                      src="@/assets/images/icons/avatar.svg"
                      alt="user"
                      class="profile-avatar"
                  />
                  <span class="navbar__username">
                    {{ user.last_name }} {{ user.first_name }} {{ user.patronymic }}
                  </span>
                </a-button>
              </template>

              <template #overlay>
                <a-menu>
                  <a-menu-item>
                    <router-link class="navbar-sec__link profile-menu__element" to="/profile">
                      <span>Профиль</span>
                    </router-link>
                  </a-menu-item>

                  <a-sub-menu v-if="getRight('superadmin')" key="admin">
                    <template #title>
                      Админ
                    </template>

                    <a-menu-item v-if="getRight('orders')">
                      <router-link class="profile-menu__element" to="/orders">
                        <span>Заказы</span>
                      </router-link>
                    </a-menu-item>

                    <a-menu-item>
                      <router-link to="/organizations">Компании</router-link>
                    </a-menu-item>

                    <a-menu-item>
                      <router-link to="/new_reports/texts">Работа с текстами</router-link>
                    </a-menu-item>

                    <a-menu-item>
                      <router-link to="/subscription/list">Подписки</router-link>
                    </a-menu-item>

                    <a-menu-item>
                      <router-link to="/company_subscriptions/list">Купленные подписки</router-link>
                    </a-menu-item>

                    <a-menu-item>
                      <router-link to="/relations">Связь с сайтом</router-link>
                    </a-menu-item>

                    <a-menu-item>
                      <router-link to="/admin/staff">
                        {{ getRight("usersList") ? "Пользователи" : "Сотрудники" }}
                      </router-link>
                    </a-menu-item>

                    <a-menu-item>
                      <router-link to="/whiteListTable">Статистика API</router-link>
                    </a-menu-item>
                  </a-sub-menu>

                  <a-menu-item key="logout" @click="logout">
                    Выход
                  </a-menu-item>
                </a-menu>
              </template>
            </a-dropdown>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import {ref} from '@vue/reactivity';
import {useStore} from 'vuex';
import {computed} from '@vue/runtime-core';
import NotificationWindow from './NotificationWindow.vue';
import {useRoute, useRouter} from 'vue-router';
import BackCabinetBtn from '../Technical/BackCabinetBtn.vue';
import BackPageBtn from './BackPageBtn.vue';
import useCheckRights from "./../../mixins/useCheckRights";
import TextHeader from "@/components/Header/TextHeader.vue";
import SearchHeader from "@/components/Header/SearchHeader.vue";
import {LeftOutlined} from "@ant-design/icons-vue";
import cutString from "@/mixins/stringHelper";

export default {
  components: {LeftOutlined, NotificationWindow, BackCabinetBtn, BackPageBtn},
  name: 'new-header-component',
  inject: ['imageUrl'],
  props: {
    sidebarCollapsed: Boolean
  },
  setup() {
    const store = useStore(),
        router = useRouter(),
        {getRight} = useCheckRights(),
        route = useRoute();
    const profileMenuOpen = ref(false),
        showAdminMenu = ref(false),
        onSwitch = ref(true),
        user = computed(() => store.state.profile.profile),
        winWidth = computed(() => store.state.width);
    const permittedSubscriptions = computed(() => store.state.subscription.permittedSubscriptions);

    const headerDetails = computed(() => {
      return {
        main: {
          back: false,
          label: 'Моя компания'
        },
        staff: {
          back: true,
          label: 'Сотрудники',
          type: 'staff',
        },
        groups: {
          back: false,
          label: 'Группы',
          type: 'group',
        },
        group: {
          back: true,
          link: '/groups',
          label: computed(() => cutString((store.state?.group?.group?.group?.name ?? ''), 13)),
          type: 'staff',
        },
        analytics: {
          back: false,
          label: 'Аналитика',
          type: null,
        },
        analytics_detail: {
          back: true,
          link: '/analytics/reports',
          label: store.state.analytics.analyticsHeader ?? 'Аналитика',
          type: null,
        },
        personal_account: {
          back: false,
          label: 'Личный кабинет',
        },
        testing: {
          back: false,
          label: 'Тест эмоционального интеллекта',
        },
        passing: {
          back: false,
          label: 'Тест эмоционального интеллекта',
        },
        not_testing: {
          back: false,
          label: 'Тест эмоционального интеллекта',
        },
        staff_edit: {
          back: true,
          link: '/staff',
          label: 'Профиль сотрудника',
        },
        staff_view: {
          back: true,
          link: '/staff',
          label: 'Профиль сотрудника',
        },
        development: {
          back: false,
          link: '/my-development',
          label: 'Мое развитие',
        },
        my_orders: {
          back: false,
          link: '/my-orders',
          label: 'Заказы и подписки',
          type: 'order',
        },
        instruments: {
          back: false,
          link: '/instruments',
          label: 'Ежедневные помощники',
          type: 'staff',
        },
        rating: {
          back: false,
          link: '/rating',
          label: 'Оценка',
          type: 'staff',
        },
        courses: {
          back: false,
          link: '/courses',
          label: 'Развитие',
          type: 'staff',
        },
        profile: {
          back: false,
          label: 'Профиль',
        },
        detailed: {
          back: true,
          link: store.state.test.specialDetailRoute ?? '/rating',
          label: 'Сводная таблица',
          type: 'staff',
        },
        company_edit: {
          label: 'Компания',
        },
        my_development: {
          label: 'Мое развитие'
        },
        faq: {
          label: 'Помощь с ЛК'
        },
        analytics_dashboard: {
          label: 'Мониторинг',
        },
        analytics_reports: {
          label: 'Отчеты',
        },
        profiles_report: {
          label: 'Эталонный профиль',
          back: '/analytics/reports'
        }
      }
    });

    const goBack = (url) => {
      if (window.history.length > 1) {
        router.back();
      } else {
        router.push(url);
      }
    };

    const logout = () => {
      store.dispatch('logout');
    };

    const clickOnSpecial = () => {
      document.getElementById('specialButton').click();
    };

    const closeLeave = () => {
      showAdminMenu.value = !showAdminMenu
    }

    const handleOpenChange = (open) => {
      profileMenuOpen.value = open;
    }

    const isMobile = window.innerWidth <= 768;

    const headerByRouteName = {
      group: SearchHeader,
      groups: SearchHeader,
      staff: SearchHeader,
      my_orders: SearchHeader,
      rating: SearchHeader,
      courses: SearchHeader,
      instruments: SearchHeader,
      detailed: SearchHeader,
    };

    const headerComponent = computed(() => {
      return headerByRouteName[route.name] ?? TextHeader;
    });

    return {
      clickOnSpecial,
      profileMenuOpen,
      user,
      winWidth,
      router,
      route,
      logout,
      getRight,
      showAdminMenu,
      closeLeave,
      onSwitch,
      permittedSubscriptions,
      handleOpenChange,
      isMobile,
      headerComponent,
      headerDetails,
      goBack
    };
  },
};
</script>

<style lang="scss" scoped>

.logo-img {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    display: block;
    width: 104px;
  }
}

.navbar :deep(:where(.ant-btn)) {
  padding: 20px 10px !important;
  border: none !important;

  @media (max-width: $mobile-breakpoint) {
    padding: 0 !important;
  }
}

.panel-body {
  margin: 4px 20px 0 0;
}

.navbar__icons {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;

  //@media(max-width: $mobile-breakpoint) {
  //  display: none;
  //}
}

.navbar__icons li {
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
}

.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 2px;
  background-color: #eceeef;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #3D3D3D;
}

input:focus + .slider {
  box-shadow: 0 0 1px #3D3D3D;
}

input:checked + .slider:before {
  -webkit-transform: translateX(18px);
  -ms-transform: translateX(18px);
  transform: translateX(18px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.specialButton {
  width: 16px;
  height: 16px;
  margin-right: 10px;
  transition: filter 0.2s;
}

.specialButton:hover {
  filter: opacity(0.8)
}

.container {
  width: 97%;
  padding: 0 20px;
  margin: auto;
  position: relative;
  z-index: 4;
}

nav {
  color: rgba(255, 255, 255, 0.5);
  position: fixed;
  z-index: 4;
  top: 0;
  width: 100%;
  right: 0;
}

.navbar {
  margin-top: 12px;
  position: relative;
  height: 48px;
  justify-content: flex-end;
  font-family: "Open Sans", sans-serif;

  &__top-links {
    -webkit-box-flex: 1;
    -ms-flex: 1 1;
    flex: 1 1;
    flex-wrap: wrap;
  }

  &__link {
    line-height: 62px;
    font-size: 1.077rem;
    padding: 0 18px;
  }

  &__technical-btns {
    margin-left: 285px;
  }

  &__icons {
    margin-right: 24px;
    position: relative;

    button {
      color: rgba(0, 0, 0, 0.5);
      padding: 14px;
      display: block;
    }

    button:hover {
      color: rgba(0, 0, 0, 0.75);
    }

    @media (max-width: $mobile-breakpoint) {
      margin-right: 20px;
    }
  }

  &__icon {
    margin-top: 5px;
  }

  &__profile {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    cursor: pointer;
    z-index: 4;

    img {
      height: 24px;
      width: 24px;
      object-fit: cover;
      object-position: center;
      border-radius: 50%;

      @media (max-width: $mobile-breakpoint) {
        height: 32px;
        width: 32px;
      }
    }
  }

  &__username {
    margin-left: 10px;
    font-family: "Open Sans", sans-serif;
  }

  &__technical-btns {
    display: none;
  }

  @media (max-width: $mobile-breakpoint) {
    &__username {
      display: none;
    }

    &__profile {
      padding-left: 5px;
      padding-right: 0;
    }

    .angle-down {
      margin-left: 12px;
    }

    .profile-menu {
      right: -30px;
    }

    .logo-img {
      display: block;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      height: 30px;
      width: auto;
    }
  }
}

.notifications {
  display: flex;
  height: 16px;
}

.header-navigation {
  margin-left: 240px;
  margin-right: auto;
}

.header-navigation-wrapper {
  margin-left: 260px;
  margin-right: auto;
  color: var(--main-font);
  display: flex;
  column-gap: 10px;
  align-items: center;

  @media (max-width: $mobile-breakpoint) {
    display: none;
  }
}

.back-button-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: #FFFFFF;
  border-radius: 25%;
  cursor: pointer;
}
</style>